import { z } from 'zod';

export const depositConfigSchema = z.object({
  balanceVnd: z.number().int().min(0),
  balanceAsOf: z.string().datetime(),
  perTxnCostVnd: z.number().int().min(1),
  lowThresholdVnd: z.number().int().min(0),
});
export type DepositConfigInput = z.infer<typeof depositConfigSchema>;

export const remapSchema = z.object({
  orgId: z.string().min(1),
  companyXid: z.string().min(1),
});
export type RemapInput = z.infer<typeof remapSchema>;

export const companyStatusSchema = z.object({
  status: z.enum(['Active', 'Suspended', 'Terminated']),
});
export type CompanyStatusInput = z.infer<typeof companyStatusSchema>;

/** PUT /api/bank-accounts/primary (THI-347): the SePay bank-account xid to
 *  print on every VietQR from now on. Must be one of the company's active
 *  accounts; the route checks that against SePay, not the body. */
export const setPrimaryBankAccountSchema = z.object({
  bankAccountXid: z.string().min(1).max(64),
});
export type SetPrimaryBankAccountInput = z.infer<typeof setPrimaryBankAccountSchema>;
